import { type Component, Index, Show } from 'solid-js'

import { Field, Select, Text, createListCollection } from '@components'
import { type PatternSpecificationEnum, patternSpecificationList } from '@here/api'
import { ChevronDownIcon } from 'lucide-solid'
import { useService } from 'solid-services'
import { useFilters } from '../state/filter'
import { LastSelectDisabled } from './LastSelectDisabled'

export const PatternSpecification: Component = () => {
	const { filters, setPatternSpecification } = useService(useFilters)()

	const collection = createListCollection({ items: patternSpecificationList })

	const selected = () => filters().patternSpecification

	return (
		<Field.Root>
			<Field.Label>Pattern Specification</Field.Label>
			<Select.Root
				positioning={{
					sameWidth: true,
				}}
				multiple
				value={selected()}
				collection={collection}
				onValueChange={({ value }) => {
					setPatternSpecification(value as PatternSpecificationEnum[])
				}}
			>
				<Select.Control>
					<Select.Trigger height="auto">
						<Select.ValueText
							asChild={(props) => (
								<Show
									when={selected().length < patternSpecificationList.length}
									fallback={<Text py={2}>All Selected</Text>}
								>
									<Text
										py={2}
										{...props}
									/>
								</Show>
							)}
						/>
						<Select.Indicator>
							<ChevronDownIcon />
						</Select.Indicator>
					</Select.Trigger>
				</Select.Control>
				<Select.Positioner>
					<Select.Content>
						<Select.ItemGroup>
							<Index each={collection.items}>
								{(item) => (
									<LastSelectDisabled
										item={item()}
										selected={selected()}
									/>
								)}
							</Index>
						</Select.ItemGroup>
					</Select.Content>
				</Select.Positioner>
				<Select.HiddenSelect />
			</Select.Root>
		</Field.Root>
	)
}
